import { createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { IdNamePair } from '../../@models/index';
import { Injectable, Injector } from '@angular/core';
import { ContactService } from '../../@services/contacts.service';
import { DropdownService } from '../../@services';
import { ENDPOINTS } from 'src/app/@config/endpoints';

@State<IdNamePair[]>({
  name: 'taskStatus',
  defaults: []
})
@Injectable()
export class TaskStatusState {

  private static service: DropdownService

  static hasAny() {
    return createSelector([TaskStatusState], (state: IdNamePair[]) => {
      return state.length > 0;
    });
  }

  constructor(injector: Injector) {
    TaskStatusState.service = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<TaskStatusState>) {
    this.service.getDropdownData(ENDPOINTS.getTaskStatus()).subscribe(
      (data: IdNamePair[]) => {
        setState(data);
      }
    );
  }

  static getNameById(id: number) {
    return createSelector([TaskStatusState], (state: IdNamePair[]) => {
      return state.find((item: IdNamePair) => item.id === id).name;
    });
  }

}
